import * as types from '@/store/types'

export default {
	[types.MUTATE_NOTIFICATION_ID]: (state, payload) => {
        state.notificationId = payload
    },
    [types.MUTATE_PURPOSE_ID]: (state, payload) => {
        state.purposeId = payload;
    },       
    [types.MUTATE_PURPOSE_OTHERS]: (state, payload) => {
        state.otherPurpose = payload;
    },
    [types.MUTATE_PHOTOS]: (state, payload) => {
        state.photos = payload;
    },
    [types.MUTATE_VENUES]: (state, payload) => {
        state.venues = payload;
    },
    [types.MUTATE_REQUEST_TYPE_ID]: (state, payload) => {
        state.requestTypeId = payload;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/temp_venue/mutations.js